(function () {
    'use strict';

    angular
        .module('oddRoutes')
        .controller('ODDBusinessUnitController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'notificationService'];

    function Controller($scope, $state, $stateParams, notificationService) {

        $scope.activeState = $state.current.name;
        $scope.isSurvey = false;

        if ($stateParams.CampaignTypeCode === 'odd') {
            $scope.views = [{
                linkState: 'odd.campaignStatusMgmt',
                includedStates: ['odd.addExternalParty', 'odd.externalPartyEdit'],
                name: 'Partners',
                view: 'externalParties'
            }, {
                linkState: 'odd.questionnaireTemplatesEdit',
                name: 'Questionnaire Templates',
                view: 'questionnaireTemplatesEdit'
            }];
        } else if ($stateParams.CampaignTypeCode === 'surveyv2') {
            $scope.isSurvey = true;
            $scope.views = [{
                linkState: 'odd.surveyCampaigns',
                includedStates: ['odd.surveyCampaign', 'odd.surveyCampaignEdit'],
                name: 'Campaigns',
                view: 'surveyCampaigns'
            }];
        } else {
            notificationService.warn('The page you tried to access does not exist or you do not have the necessary permissions to access it');
            $state.go('home', { UserItemPersonID: $scope.authenticatedUser.ItemPersonID }, { location: 'replace' });
            return;
        }

        if ($state.is('odd')) {
            $state.go($scope.views[0].linkState, $stateParams, {location: 'replace'});
            return;
        }

        $scope.activeStateIndex = _.findIndex($scope.views, function (view) {
            if ($state.includes(view.linkState)) return true;

            return _.some(view.includedStates, function (state) {
                return $state.includes(state);
            });
        });

    }
})();